/**
 * @module app.bdc.reports.bdcFlashupCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function BDCFlashupCtrl($scope, $window, $rootScope, pricesService, flashupService) {
        var self = {};
        self.orderForm = $rootScope.orderForm;

        if (!self.orderForm) {
            return $scope.goTo('/list');
        }

        self.order = $rootScope.order;
        pricesService.setOrderForm(self.orderForm);
        pricesService.setOrder(self.order);
        self.flashupService = flashupService;

        /**
         * Gate the date of the day
         * @return {String}
         */
        self.getDate = function getDate() {
            return moment().format('DD/MM/YYYY');
        };

        /**
         * Get the date installation, only defined when the order has been signed
         * @return {String}
         */
        self.getDateInstallation = function getDateInstallation() {
            return self.order.dateInstallation
                ? moment(self.order.dateInstallation, 'YYYY-MM-DD').format('MMMM YYYY')
                : null;
        };

        self.flashups = [];
        self.flashupContractType = '';
        self.isFlashupBoxOption = flashupService.isFlashupBoxOption;

        /**
         * Init the flashup collection
         */
        function _initFlashupList() {
            for (var i = 0; i < self.order.options.length; i++) {
                if (self.order.options[i].optionType.code === 'FLASHUP') {
                    self.flashupContractType = self.order.options[i].contractType;
                    self.flashups.push(self.order.options[i]);
                }
            }
        }

        _initFlashupList();

        return self;
    }

    BDCFlashupCtrl.$inject = ['$scope', '$window', '$rootScope', 'pricesService', 'flashupService'];

    angular.module('app.bdc.reports.bdcFlashupCtrl', []).controller('BDCFlashupCtrl', BDCFlashupCtrl);
});
